import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Location } from '@cpd-app/core-module/models';
import { HotSpotLocation } from '@cpd-app/generated';

export const hotSpotsFeatureKey = 'hotspots';

export interface HotSpotsState {
  locations: Location[];
  occupationHotSpots: HotSpotLocation[];
  occupationDemandInUserHomeArea: HotSpotLocation[];
  occupationDemandbyArea: HotSpotLocation[];
}
export const hotSpotsStateStateAdapter: EntityAdapter<Location> =
  createEntityAdapter<Location>({
    selectId: (location) => location.name ?? ''
  });

export const initialhotspotstate: HotSpotsState =
  hotSpotsStateStateAdapter.getInitialState({
    locations: [],
    occupationHotSpots: [],
    occupationDemandInUserHomeArea: [],
    occupationDemandbyArea: []
  });

export const { selectAll, selectEntities, selectIds, selectTotal } =
  hotSpotsStateStateAdapter.getSelectors();
